module.exports = __webpack_public_path__ + "media/images/icons/refresh-19f8a8c3e1007d14de5a396b5b4b0ae3.svg";